const DEFAULT_LOCAL_API_URL = "http://127.0.0.1:8080";
const FALLBACK_API_URL = "https://careermove-api.vercel.app";

export function getApiTargets(configuredApiUrl: string, isProd: boolean) {
  const trimmed = configuredApiUrl.trim().replace(/\/$/, "");
  if (trimmed) {
    return [trimmed];
  }
  if (isProd) {
    return ["", FALLBACK_API_URL];
  }
  return [DEFAULT_LOCAL_API_URL];
}
